import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCheckMaintenance, getLanguageData, getMenubar, getNotificationsData, postReadNotifications } from "../../../helpers/backend_helper";
import { setMenuData, setMenuDataError, setUnseenNotifications } from "./reducer";
import {checkMaintenance} from '../login/helper';

/**
 * Redux action creator for fetching menu data for the current user.
 * @function
 * @async
 * @param {function} dispatch - The Redux dispatch function.
 * @param {function} getState - The function to get the current Redux state.
 * @throws {Error} If there is an issue with the asynchronous operation.
*/
export const getMenuData = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    // const { token, userId } = getState().Login.user.data;
    let response = await getMenubar()
      .then(res => res)
      .then(data => {
        return new Promise((resolve, reject) => {
          resolve(data);
        })
      });
    if (response.status === 'ok') {
      dispatch(setMenuData(response.data));
    } else {
      throw response;
    }
  } catch (error) {
    // console.log(error);
    checkMaintenance(dispatch, error);
    // console.log(error);
    dispatch(setMenuDataError((language[error?.code] || 'Something went wrong')));
  }
};

export const getLanguage = createAsyncThunk("menudata/getLanguageData", async () => {
  try {
    let response = await getLanguageData();
    return response.data;
  } catch (error) {
    // console.log(error);
    checkMaintenance(dispatch, error);
  }
});

export const setClientPath = createAsyncThunk("menudata/setClientPathData", async (id, {dispatch, getState}) => {
  try {
    return id;
  } catch (error) {
    // console.log(error);
  }
});

export const setBrandPath = createAsyncThunk("menudata/setBrandPathData", async (id, {dispatch, getState}) => {
  try {
    return id;
  } catch (error) {
    // console.log(error);
  }
});

export const setMarketPath = createAsyncThunk("menudata/setMarketPathData", async (id, {dispatch, getState}) => {
  try {
    return id;
  } catch (error) {
    // console.log(error);
  }
});

export const getNotifications = createAsyncThunk('notifications/getNotificationsData', async (params, {dispatch, getState}) => {
  try {
    const res = await getNotificationsData();
    if (res.status === 'ok') {
      return res.data;
    } else {
      throw res;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return [];
  }
})

export const sendNotificationSeen = (ids) => async (dispatch, getState) => {
  try {
    const res = await postReadNotifications({ids});
    if (res.status === 'ok') {
      dispatch(setUnseenNotifications(0));
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}